
export const getEmptyOrderProduct = ()=>({
    product: null,
    price: 0,
    quantity: 1,
    isReward: false
});
